import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_tshirts: FaireCategoryEntity = {
  token: "cat_women-tshirts",
  type: "category",
  name: "T-shirts & tank tops",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/tshirts-tanktops",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
